var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1834 7.24996C16.3167 3.39163 12.95 1.66663 10 1.66663C10 1.66663 10 1.66663 9.9917 1.66663C7.05004 1.66663 3.6917 3.39163 2.8167 7.24163C1.83337 11.5416 4.4667 15.1833 6.85004 17.4833C7.73337 18.3333 8.8667 18.7583 10 18.7583C11.1334 18.7583 12.2667 18.3333 13.1417 17.4833C15.525 15.1833 18.1584 11.55 17.1834 7.24996ZM12.7334 7.94163L9.40004 11.275C9.27504 11.4 9.1167 11.4583 8.95837 11.4583C8.80004 11.4583 8.6417 11.4 8.5167 11.275L7.2667 10.025C7.02504 9.78329 7.02504 9.38329 7.2667 9.14163C7.50837 8.89996 7.90837 8.89996 8.15004 9.14163L8.95837 9.94996L11.85 7.05829C12.0917 6.81663 12.4917 6.81663 12.7334 7.05829C12.975 7.29996 12.975 7.69996 12.7334 7.94163Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b4a223b9e8909270f85692cdaba99551.svg";
export { ForwardRef as ReactComponent };